import { render, staticRenderFns } from "./SdTag.html?vue&type=template&id=340ce960&external"
import script from "./SdTag.ts?vue&type=script&lang=ts&external"
export * from "./SdTag.ts?vue&type=script&lang=ts&external"
import style0 from "./SdTag.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports